import {
  IAccessRangeForRolesEnvelope
} from 'types/accessRangeForRole';
import request from './index';

export type AccessRangeForRoleNestedAttribute =
  | {
      id?: string;
      account_role: string;
      view_area_scope: string;
      edit_area_scope: string;
    }
  | { id: string; _destroy: '1' };

export interface IAccessRangeForRolesPatchBody {
  company: {
    access_range_for_roles_attributes: AccessRangeForRoleNestedAttribute[];
  };
}

export const getAccessRangeForRoles = (companyId: string) =>
  request<IAccessRangeForRolesEnvelope>({
    options: {
      url: `/companies/${companyId}/access_range_for_roles`,
      method: 'get'
    }
  });

export const patchAccessRangeForRoles = (
  companyId: string,
  body: IAccessRangeForRolesPatchBody
) =>
  request<IAccessRangeForRolesEnvelope>({
    options: {
      url: `/companies/${companyId}/access_range_for_roles`,
      method: 'patch',
      data: body
    }
  });
